import { buildReducer } from '../../../../shared';
import { loadSuggestedPersonasCompletedAction } from '../../../../hub';
import type { SuggestedPersonasState } from '../../../state/data/hubDataState';

export default buildReducer<SuggestedPersonasState>()
    .handleDataAction(
        loadSuggestedPersonasCompletedAction,
        (_state, action) => ({
            isError: false,
            isLoading: false,
            personas: action.payload.suggestedPersonas,
        }),
        (_state, action) => ({ isError: true, isLoading: false, personas: [] })
    )
    .done({
        personas: [],
        isError: false,
        isLoading: true,
    });
export type { Action } from '../../../../shared';
